//ADD sendAsBinary compatibilty to older browsers
if(!XMLHttpRequest.prototype.sendAsBinary) {
  XMLHttpRequest.prototype.sendAsBinary = function(string) {
    let bytes = Array.prototype.map.call(string, function(c) {
      return c.charCodeAt(0) & 0xff;
    });
    if(!Uint8Array) return;
    this.send(new Uint8Array(bytes).buffer);
  };
}

function createXhr() {
  let xhr = null;
  if(window.XMLHttpRequest) {
    xhr = new window.XMLHttpRequest();
  } else {
    xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
  }
  if(!xhr) {
    throw new Error('您的系统或浏览器不支持XHR对象！');
  } else {
    return xhr;
  }
}

export default function http(option) {
  // new Promise
  const xhr = createXhr();
  const method = option.method && option.method.toUpperCase();

  let form = null;
  if(!window.FormData) {
    return new Error('浏览器不支持 FormData');
  }
  const formData = new FormData();
  if(option.data && ({}).toString.call(option.data) === '[object Object]') {
    Object.keys(option.data).forEach(key => {
      formData.append(key, option.data[key]);
    });
  }
  if(option.file && option.filename) {
    formData.append('file', option.file);
  }

  if(xhr.upload) {
    xhr.upload.onprogress = function(e) {
      if(e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      // 触发进度
      option.onProgress(e);
    }
  }

  xhr.onerror = function(e) {
    option.onError(e)
  };

  xhr.onload = function() {
    if(xhr.status < 200 && xhr.status >= 300) {
      option.onError(getError(url, xhr));
    }
    option.onSuccess(getBody(xhr));
  };

  xhr.open('POST', option.action, true);

  if(option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  if(option.headers && ({}).toString.call(option.headers) === '[object Object]') {
    Object.keys(option.headers).forEach(key => {
      xhr.setRequestHeader(key, option.headers[key]);
    });
  }

  xhr.send(formData);

  return xhr
}

function getError(url, xhr) {
  let msg;
  if(xhr.response) {
    msg = `${xhr.response.error || xhr.response}`;
  } else if(xhr.responseText) {
    msg = `${xhr.responseText}`;
  } else {
    msg = `fail to post ${url} ${xhr.status}`;
  }

  const err = new Error(msg);
  err.status = xhr.status;
  err.method = 'post';
  err.url = url;
  return err;
}

function getBody(xhr) {
  const text = xhr.responseText || xhr.response;
  if(!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch(e) {
    return text;
  }
}



// WEBPACK FOOTER //
// ./src/components/Upload/xhr.js